import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { portfolio } from "../data/siteData";

const Portfolio = () => {
  const [open, setOpen] = useState(null);

  return (
    <div data-testid="portfolio-page" className="bg-[#0a0a0a] pt-24 pb-10 lg:pt-28 lg:pb-16">
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 mb-10 lg:mb-16">
        <p className="text-[var(--accent)] text-xs tracking-[0.32em] uppercase mb-5">The Work</p>
        <h1 className="font-display text-white text-[clamp(56px,10vw,170px)] leading-[0.9]">
          Our
          <br />
          <span className="font-elegant italic font-light">portfolio.</span>
        </h1>
        <p className="text-white/70 max-w-2xl mt-5 lg:mt-8 leading-relaxed">
          Selected work from Society — a curated collection of transformations,
          rituals, and moments where bold beauty meets unapologetic luxury.
        </p>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {portfolio.map((src, i) => (
            <button
              key={i}
              onClick={() => setOpen(src)}
              data-testid={`portfolio-tile-${i}`}
              className="tile aspect-square group relative cursor-zoom-in"
            >
              <img src={src} alt={`Society work ${i + 1}`} loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                <p className="font-display text-white text-2xl">View →</p>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-14 lg:mt-24 text-center">
          <h2 className="font-display text-white text-[clamp(36px,5vw,80px)] leading-[0.95]">
            Want to be
            <br />
            <span className="font-elegant italic font-light">the next?</span>
          </h2>
          <Link to="/bookings" className="btn-accent mt-6 lg:mt-8" data-testid="portfolio-book-cta">
            Book Now <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      {open && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setOpen(null)}
          data-testid="portfolio-lightbox"
        >
          <button
            className="absolute top-6 right-6 text-white/80 hover:text-[var(--accent)]"
            onClick={() => setOpen(null)}
            data-testid="lightbox-close"
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <img
            src={open}
            alt="Portfolio detail"
            className="max-h-[88vh] max-w-[88vw] object-contain rounded-md"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Portfolio;
